import { StyledBackArrowHeader } from "../../styled/BackArrowHeader";

const BackArrowHeader = ({ onClick, title }) => {
  return (
    <StyledBackArrowHeader.Container
      title={title ?? "Atrás"}
      onClick={onClick}
    >
      <StyledBackArrowHeader.BackArrow />
    </StyledBackArrowHeader.Container>
  );
};

export default BackArrowHeader;
